import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph, Heading1, Span, Heading2, LinkStyled,
} from '../../components/typography';
import PageLink from '../../components/PageLink';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Price } from '../../containers/commerce';
import Datoer from '../../components/Datoer';
import RowProductView from '../../components/grid/RowProductView';


export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Fadoel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Fadøl</Heading1>
          <Paragraph>
            Med <Datoer type="experience" /> års erfaring med levering af fadøl, har vi et bundsolidt kendskab til branchen og ved hvad der kræves, for at gøre enhver fadølselsker glad og tilfreds. Herunder finder du vores enorme udvalg af fadøl, samt tilbehør, udstyr og al nyttig information du måtte have brug for.
          </Paragraph>
          <Paragraph>
            <Span fontWeight="bold" fontSize="16px">Husk fadølsanlægget</Span><br />
            Har du ikke selv et fadølsanlæg, så husk at <LinkStyled to="/fadoelsanlaeg">lej fadølsanlæg</LinkStyled> til de fustager du køber.
          </Paragraph>
          <Paragraph>
            <Span fontWeight="bold" fontSize="16px">Returnér dine ubrugte fustager</Span><br />
            Betal kun for det I drikker - Fustager der ikke er brugt, refunderes til fuld pris minus <Price varenr="641" /> kr. pr. stk.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <PageLink
          title="Pilsner"
          link="/fadoel/pilsner"
          image1="produkter-fadoel.skovlyst-birkebryg.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.groen-tuborg.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Stort udvalg af Pilsner-fadøl. Tuborg, Carlsberg, Royal til Skovlyst, Nørrebro og Svaneke.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Classic"
          link="/fadoel/classic"
          image1="produkter-fadoel.tuborg-classic.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.skovlyst-egebryg.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Stort udvalg af Classic-fadøl. Tuborg, Carlsberg, Royal til Albani, Hancock og Svaneke.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Hvedeøl"
          link="/fadoel/hvedeoel"
          image1="produkter-fadoel.8495-flaske.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.8855-flaske.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Hvede-fadøl. Flere forskellige typer - fra Kronenbourg 1664 Blanc til Hoegaarden.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="IPA"
          link="/fadoel/ipa"
          image1="produkter-fadoel.royal-oekologisk-ipa-glas.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.skovlyst-india-pale-ale.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Flere gode India Pale Ale (IPA) fadøl. Royal, Nørrebro, Skovlyst, Herslev, Schiøtz med flere.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Ale"
          link="/fadoel/ale"
          image1="produkter-fadoel.skovlyst-boegebryg.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.fuglsang-early-bird-glas.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Stort udvalg i Ale - Vælg mellem diverse Brown Ale, Lys Ale og Mørk Ale.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Porter / Stout"
          link="/fadoel/porter"
          image1="produkter-fadoel.guinness.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Porter / Stout - Vælg mellem to klassikere: Guinness eller Murphy&apos;s Irish Stout.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Craft Beer"
          link="/fadoel/craft-beer"
          image1="produkter-fadoel.40825-flaske.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Håndbryggede Craft Beer fadøl fra To Øl, Schiøtz og Kissmeyer. Findes i typer som IPA, Lys Ale og Mørk Ale.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Letøl"
          link="/fadoel/letoel"
          image1="produkter-fadoel.platan-pilsner.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Letøl og alkoholfri fadøl. Vores alkoholfri fadøl er en alkoholfri pilsner fra Tjekkiet. Letøl er fra Herslev og Vestfyen.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Cocktails, vin &amp; cider"
          link="/fadoel/cocktails-vin-cider"
          image1="produkter-fadoel.serena-vino-glas.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-oelvand.nohrlund-mango-smash.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Cocktails, vin &amp; cider på fad. Få kold æblecider ud af fadølshanen eller vælg mellem vores mange gode færdigblandede cocktails.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Oktoberfest øl"
          link="/fadoel/oktoberfest"
          image1="produkter-fadoel.paulaner-oktober-fest.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-fadoel.8495-flaske.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Gode fadøl til jeres oktoberfest. Vi fører blandt andet en af de officiele oktoberfest fadøl Paulaner.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Juleøl"
          link="/fadoel/juleoel"
          image1="produkter-fadoel.tuborg-julebryg.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Fadøl til julefrokosten eller julefesten. Vi har en række gode og populære juleøl som passer perfekt til dit event.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Påskebryg"
          link="/fadoel/paaskebryg"
          image1="produkter-fadoel.herslev-paaskebryg-logo.jpg"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Gå ind i foråret med en fadøl fra vores udvalg af påskebryg fra Nørrebro, Herslev, samt Fynsk Forår fra Ørbæk.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Dansk Fadøl"
          link="/fadoel/dansk-fadoel"
          image1="produkter-fadoel.hancock-pilsner.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Oversigt over alle vores danske fadøl fra de største producenter i Danmark til mindre lokale bryggerier.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Udenlandske øl på fad"
          link="/fadoel/udenlandske-oel-paa-fad"
          image1="produkter-fadoel.heineken.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Oversigt over alle vores udenlandske fadøl fra hele verden. Find den rette specielle øl til dit arrangement her.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Modular 20"
          link="/fadoel/modular-20"
          image1="modular20.groen-tuborg.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Modular 20 fustager. Disse fustager kræver eget Modular 20 anlæg. Vi udlejer ikke udstyret til disse fustager.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Flex 20"
          link="/fadoel/flex-20"
          image1="flex20.carlsberg-pilsner.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Flex 20 fustager (med slange) lagerføres ikke, men tages kun hjem på bestilling og mod forud betaling, ingen returret, leveringstid 4 dage.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Fadølspriser"
          link="/fadoel/priser"
          image1="produkter-fadoel.groen-tuborg.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  Se en oversigt over alle vores fadøl og sorter efter pris, land, alkoholprocent, fadkobling med mere.
                </Paragraph>
              </React.Fragment>
            )
          }
        />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading2>Vores udvalg af fadøl</Heading2>
        </Col>
        <Col xs={12} md={6}>
          <Paragraph>
            Vi har et hav af velsmagende fadøl du kan gå ombord i!
            Fra de læskende pilsnere til sommerfesten i haven, til de mørke ales til ølsmagningen. Der er ikke den lejlighed, hvor du ikke kan finde en passende fadøl hos os, når du går på opdagelse i vores udvalg. Herunder kan du se vores ekstremt brede sortiment.
          </Paragraph>
          <Paragraph>
            Til sommerfesten kan du fx. vælge blandt vores lyse hvedeøl, lyse ales og friske IPA’er. En god Classic går man heller aldrig galt i byen med, og her kan du bl.a. finde den populære Tuborg Classic, men også fadøl fra Nørrebro bryghus, Kronenbourg m.m.
          </Paragraph>
          <Paragraph>
            Står du og mangler fadøl til en ølsmagning eller de koldere efterårs- og vintermåneder, har vi også et velassorteret sortiment. Du kan vælge både Brown Ales, Mørke Ales, Porters og Stouts fra en række af de mest populære varianter. Fx Ale no. 16. Newcastle eller Jacobsen Brown Ale eller den top-populære Guinness.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Paragraph>
            Er du vild med den rå, ufiltreret smag, har vi også craft beers i en række forskellige smage. Både som IPA, Lys og mørk ale eller stout, kan du få din lyst styret her. Herunder kan du finde virkeligt velsmagende varianter fra bl.a. Kissmeyer eller To Øl.
          </Paragraph>
          <Paragraph>
            Uanset hvad du måtte ønske af lyse, klassiske, rå eller mørke fadøl, finder du helt sikkert en variant, der vil begejstre dig og dine gæster i vores sortiment.
          </Paragraph>
          <Paragraph>
            For at kunne skænke den velsmagende og læskende fadøl, kræves det helt rette udstyr. Dette finder du naturligvis også hos Skafte.
            Lej dit <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> til den kommende fest eller næste begivenhed og giv dine gæster en oplevelse, de sent vil glemme. Det er muligt at vælge mellem flere versioner af haner og anlæg, fx med eller uden bar samt en, to eller tre fadølshaner.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12} md={6}>
          <Heading2>Bestil fadøl til festlige højtider</Heading2>
          <Paragraph>
            Skal du holde Påskefrokost for vennerne og/eller familien i haven? Eller måske du skal servere fadøl til en Oktoberfest eller julefrokosten? Vi har fadøl til enhver højtid, og du kan sågar finde dem der gør sig bedst til maden, hvis du klikker på vores beregner til dette ovenfor. Så får du den fadøl der bedst komplimenterer den menu, du vil servere for dine gæster. Nemt og bekvemt, for en endnu bedre oplevelse ved højtider.
          </Paragraph>
          <Heading2>Er du mere til cocktails eller cider?</Heading2>
          <Paragraph>
            Er du mere til cocktails eller cider, eller ønsker du bare at have noget til enhver smag til din festlige lejlighed? Så er der i den grad også noget for dig. Du kan nemlig både bestille cocktails som Gin Hazz og Champagne Brus eller fx. den klassiske Sommersby Apple Cider der gør sig glimrende til sommerfesten med bagende sol- for både mænd og kvinder.
          </Paragraph>
        </Col>
        <Col xs={12} md={6}>
          <Heading2>Tag bilen hjem med vores alkoholfri- og letøl</Heading2>
          <Paragraph>
            Kan du ikke tåle alkohol, eller foretrækker blot at fadøllene du nyder ikke hæmmer mulighederne for at transportere sig hjem i bil? Så har vi både alkoholfri og letøl. Samtidig har vi gjort meget ud af, at du får kvalitetsøl og ikke skal gå på kompromis med smagen.
          </Paragraph>
          <Paragraph>
            Blandt andet kan du vælge en økologisk landøl eller en mere klassisk variant med Vestfyn Light. Så kan du roligt nyde et par fadøl eller tre med god samvittighed og tage bilen hjem med en promille langt under den tilladte grænse- eller sågar på 0‰, hvis du udelukkende nyder vores alkoholfri varianter af iskolde, lækre fadøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
